// The commercial terms, in one place.
//
// These were previously repeated across the pricing screens, and quotes now
// read them too. A price that disagrees between the public pricing page and a
// quote we've sent is a business problem, not a styling one — so they live
// here and every consumer imports them.

export const CATEGORIES = ['website', 'app'];

export const CATEGORY_LABELS = {
  website: 'Website',
  app: 'App',
};

// Monthly care plan prices, in pounds.
export const CARE_PRICES = {
  website: { essential: 45, active: 95 },
  app: { essential: 75, active: 150 },
};

export const CARE_TIER_LABELS = {
  essential: 'Essential',
  active: 'Active',
};

// How the build fee is split. Percentages must total 100 — a quote whose
// stages don't add up to the total would be worse than having no schedule.
export const PAYMENT_SCHEDULES = {
  website: [
    { percent: 50, label: 'Deposit, on acceptance' },
    { percent: 50, label: 'On launch' },
  ],
  app: [
    { percent: 40, label: 'Deposit, on acceptance' },
    { percent: 30, label: 'Build milestone' },
    { percent: 30, label: 'Before submission' },
  ],
};

// Shown on quotes and invoices, matching the public pricing page.
export const PAYMENT_NOTES = [
  'Nothing goes live and no source code is handed over until final payment clears.',
  'Invoices payable within 14 days.',
  'Third-party costs (domain, store accounts, premium plugins, stock imagery) are paid by you directly and are never in our fee.',
];

// Rounded to pennies, unlike priceMath's applyDiscount which rounds to whole
// pounds for the marketing pages — a quote has to add up exactly.
export function applyPercent(amount, percent) {
  const value = Number(amount) || 0;
  const off = Number(percent) || 0;
  return Math.round(value * (1 - off / 100) * 100) / 100;
}

export function carePriceFor(category, tier) {
  return CARE_PRICES[category]?.[tier] ?? null;
}

export function scheduleFor(category) {
  return PAYMENT_SCHEDULES[category] || PAYMENT_SCHEDULES.website;
}

// Splits a total across a schedule. The last stage absorbs any rounding
// remainder so the stages always sum to exactly the total.
export function splitTotal(total, schedule) {
  const amount = Number(total) || 0;
  let allocated = 0;
  return schedule.map((stage, i) => {
    const isLast = i === schedule.length - 1;
    const value = isLast
      ? Math.round((amount - allocated) * 100) / 100
      : Math.round(amount * (stage.percent / 100) * 100) / 100;
    allocated += value;
    return { percent: stage.percent, label: stage.label, amount: value };
  });
}
